import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { format } from "date-fns";
import {Helmet} from "react-helmet";
import { Container, Button, Col, Row, Nav, NavDropdown } from "react-bootstrap";
import {
  Arrow90degUp,
  ArrowUp,
  ChevronDoubleLeft,
  ChevronDoubleRight,
  Pen,
  PencilSquare,
  Person,
  PersonAdd,
  Plus,
  PlusCircle,
  SkipBackward,
  Star,
  StarFill,
  Trash,
} from "react-bootstrap-icons";
import Accordion from "react-bootstrap/Accordion";
import "./style.css";
import { SlArrowRight, SlMenu, SlUser, SlUserFollow } from "react-icons/sl";
import { FaUserLarge } from "react-icons/fa6";
import { BsBoxArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../../../services/api";
import Modal from 'react-bootstrap/Modal';
import Collapse from 'react-bootstrap/Collapse';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Header from "../inc/Header";
import SideBar from "../Componet/Sidebar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const SuperHomeDesktop = () => {
  const [companies, setCompanies] = useState([]);
  const [companyAdmins, setCompanyAdmins] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState('');
 
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [addMode , setAddMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handledClose = () => setShow(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const [editedAddress, setEditedAddress] = useState("");
  const [editedName, setEditedName] = useState("");
  const [edittype, setEditType] = useState("");
  const [compid, setCompId] = useState(0); 
  const [editedVatNumber, setEditedVatNumber] = useState("");
  const [editedContactName, setEditedContactName] = useState("");
  const [editedContactEmail, setEditedContactEmail] = useState("");
  const [editedContactPhone, setEditedContactPhone] = useState("");
  const session_username = sessionStorage.getItem("name");
  const session_email = sessionStorage.getItem("email");
  const session_role = sessionStorage.getItem("role");
  const [formData, setFormData] = useState({
    companyname: '',
    type: '',
    address: '',
    vatnumber: '',
    contactname: '',
    contactemail: '',
    contactphone: '',
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDeleteCompany = (companyId) => {
    // Make an Axios DELETE request to delete the selected company
    axios.delete(`${baseUrl}/company/${companyId}`)
      .then(response => {
        // Handle the response if needed
        console.log(response.data);

        // Update the list of companies after deleting one
        
        setCompanies(companies.filter(company => company.id !== companyId));
        setSmShow(false);
        alert("Deleted company sucssfully");
         
        window.location.reload();
      })
      .catch(error => {
        // Handle errors if any
        console.log(" Not Deleted company sucssfully");
        console.error('Error deleting company:', error);
      });
  };
  const handleAddChange = () => {
 
    axios.post(`${baseUrl}/company`, formData)
      .then(response => {
        toast.success("Company Added successfully");
        window.location.reload();
        
        console.log(response.data);
      })
      .catch(error => {
        toast.error("Company Not Added");
        console.error('Error saving data:', error);
      });
  };
  useEffect(() => {
    handlefeachadmin(compid);
    if (selectedCompany) {
      setEditedName(selectedCompany.companyname || "")
      setEditType(selectedCompany.type || "");
      setEditedAddress(selectedCompany.address || "");
      setEditedVatNumber(selectedCompany.vatnumber || "");
      setEditedContactName(selectedCompany.contactname || "");
      setEditedContactEmail(selectedCompany.contactemail || "");
      setEditedContactPhone(selectedCompany.contactphone || "");
    }

  }, [selectedCompany]);
  

  const handlefeachadmin = (companyid) => {
    axios
    .get(`${baseUrl}/company/${companyid}/admins`)
    .then((value) => {
      console.log("THEVALUE", value);
      setCompanyAdmins(value.data);
    });
  } 
  function logout() {
    sessionStorage.clear();
    navigate("/login");
  }
  const [refresh, setRefresh] = useState(false);

  
  const handleRefresh = () => {
    
    setRefresh((prevRefresh) => !prevRefresh);
  };
  useEffect(() => {
    var item_value = sessionStorage.getItem("login");
  
   
    if (item_value != "1" ) {
      navigate("/login");
    }
    if( session_role != "super"){
      navigate("/login");
    }
    axios.defaults.headers.common = {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    };
    axios
      .get(`${baseUrl}/company`)
      .then((value) => {
        console.log("THEVALUE", value);
        
        setCompanies(value.data);
      })
      .catch((reason) => {
        console.log("reason", reason.response.data);
        if (reason.response.data.includes("Token")) {
          navigate("/login");
        }
      });


  const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024); // Adjust the threshold as needed
    };

    // Initial check
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);
   const onEdit =() =>{
    setEditMode(true);
    setAddMode(false);
   }
   const OnAdd = () =>{
    setEditMode(false);
    setSelectedCompany(null);
    setAddMode(true);
   }

   const handleAddAdmin = () => {
    // Assuming you have an API call to add admins to the company
    inputFields.forEach((admin) => {
      const data = {
        companyid: selectedCompany.id,
        firstname: admin.fname,
        lastname: admin.lname,
        email: admin.email,
      };
  
      // Make your API call using axios
      axios.post(`${baseUrl}/user`, data)
        .then((response) => {
        console.log('Admin added successfully', response.data);
        navigator.clipboard.writeText(response.data.user.password);
        toast.success('Admin password copied please share to user', {
          position: 'top-center',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        
      });

         handleRefresh(); 
        //  window.location.reload();
        }
        
        )
        .catch((error) => {
          toast.error("sorry this email is regesterd");
          // Handle error if needed
        });
    });
  };
  
   const handleSaveChange = () => {
    const updatedCompany = {
      id: selectedCompany.id,
      companyname: editedName,
      type: edittype,
      address: editedAddress,
      vatnumber: editedVatNumber,
      contactname: editedContactName,
      contactemail: editedContactEmail,
      contactphone: editedContactPhone,
      // Add other fields as needed
    };

    axios
      .put(`${baseUrl}/company`, updatedCompany)
      .then((response) => {
        // Assuming the update is successful, you might want to update state or perform other actions
        console.log("Company updated successfully", response.data);
        toast.success("Company updated successfully");
        window.location.reload();
        // You may want to update state or perform other actions here
      })
      .catch((error) => {
        // Handle errors
        toast.error("Error updating company");
        console.error("Error updating company", error);
      });
  };
  const [inputFields, setInputFields] = useState([{ fname: '', lname: '', email: '' }]);

  const handleAddField = () => {
    setInputFields([...inputFields, { fname: '', lname: '', email: '' }]); // Duplicate the input field
  };

  const handleInputChange2  = (index, name, value) => {
    const updatedFields = [...inputFields];
    updatedFields[index][name] = value;
    setInputFields(updatedFields);
  };

  const handleMakePrimary = (email) => {
    // Assuming you have an API call to update the isPrimary attribute
    const data = {
      email: email,
      isPrimary: true, // Set this to true for making it primary
    };
  
    // Make your API call using axios
    axios.put(`${baseUrl}/user`, data)
      .then((response) => {
        console.log('Admin made primary successfully', response.data);
        // Handle success if needed
      })
      .catch((error) => {
        console.error('Error making user primary', error);
        // Handle error if needed
      });
  };
  
  const handleRemoveUser = (email) => {
  
   
    axios.delete(`${baseUrl}/user/${email}`)
      .then((response) => {
        console.log('User removed successfully', response.data);
        toast.success('Admin Deleted sucssfully');
        handleRefresh();
      
      })
      .catch((error) => {
        console.error('Error removing user', error);
        toast.error("Error removing admin");
        
      });
  };
 
  return (

    <>
      <ToastContainer />
     <Helmet>
        <meta charSet="utf-8" />
        <title>Super Admin Dashboard | Coffee</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
    <Modal size="sm" show={show} onHide={handleClose} animation={false} dialogClassName='custom-dialog'>
      <Modal.Header>
        <h5>Admin Profile</h5>
        <hr/>
      </Modal.Header>
      <Modal.Body>
        <div class="">
          <span >Name</span>
          <p >{session_username}</p>
        </div>
        <div class="">
          <span >Email</span>
          <p >{session_email}</p>
        </div>
      </Modal.Body>
     <Modal.Footer>
        <button class="reset-button"><div class="text-wrapper">Reset Password</div></button>
</Modal.Footer>
  
    </Modal>
   
  
      
  {isSmallScreen ? (
  
  <div class="content">   
  <div class='sidebar'>
         <SideBar/>
       
       </div>
            
       <section class = "stuff">
    <Row style={{maxHeight: '100vh', overflowY: 'auto'}}>
          
     <Col>
  

   
      {addMode ? '':
            <div style={{paddingTop:"20px", }} class="row add-button">
              <Button onClick={() => {
          setEditMode(false);
          setAddMode(true);
          
          
              }}
                 className="add-btn" style={{ fontSize: "14px", paddingLeft: '25px',  width: "90%" }}><Plus size={23} className="plus" /> Add Company</Button>
            

            </div>}
            <strong  class="d-flex justify-content-between" style={{padding: '0px 30px'}}> {addMode ? <>Add New Comapny</>: <>All Companies </> }  {addMode ? <Button onClick={()=>{setAddMode(false)}} variant="light"><ChevronDoubleLeft size={20}/></Button>: ""}</strong><hr/>
                 
                 
        
            <div style={{ margin:5 , padding: 5 }}>





{ addMode ? (


<div class="col-md-6" style={{ paddingTop: "30px", margin: 5, width: '90%', padding: 10 }}>

<div class="row justify-content-between">
  <div class="col-md-6">
  <h6>Company Name</h6>
    <input type="text" placeholder="Enter Company Name" class="form-control" value={formData.companyname}
      onChange={handleInputChange} name="companyname" />


  </div>

 <hr style={{marginTop: 10}}/> 
  <div class="col-md-6">
   
       <h6>Form Type</h6>
      <select class="form-select"
        value={formData.type}
        name="type"
        onChange={handleInputChange}
        >
         <option disabled>Select</option>
         <option value="coffees_2">Lindvalls blanket</option>
        <option value="coffees">SCA blanket</option>
       
      </select>
 
  </div>

</div>

<hr />
<div class="row justify-content-between">
  <div class="col-md-6 d-flex">
    <h6>Address</h6>
  </div>
  <div class="col-md-6 d-flex justify-content-sm-end">

    <input type="text" placeholder="Enter Company Address" value={formData.address}
      onChange={handleInputChange} class="form-control" name="address" />
  </div>
</div>
<hr />
<div class="row justify-content-between">
  <div class="col-md-6 d-flex">
    <h6>VAT No.</h6>
  </div>
  <div class="col-md-6 d-flex justify-content-sm-end">
    <input type="text" placeholder="Enter Company Vat No" class="form-control" value={formData.vatnumber}
      onChange={handleInputChange} name="vatnumber" />

  </div>
</div>
<hr />
<div class="row justify-content-between">
  <div class="col-md-2 d-flex">
    <h6>Contact</h6>
  </div>
  <div style={{marginLeft: -100}} class="col-md-10 d-flex justify-content-sm-start">
    <p>
      <label>Name</label>
      <input type="text" placeholder="Enter Contact Name" class="form-control" value={formData.contactname}
        onChange={handleInputChange} name="contactname" />

      <br />
      <label>Email</label>
      <input type="email" placeholder="Enter Contact Email" class="form-control" value={formData.contactemail}
        onChange={handleInputChange} name="contactemail" />

      <br />
      <label>Phone</label>
      <input type="phone" placeholder="Enter Contact Phone" class="form-control" value={formData.contactphone}
        onChange={handleInputChange} name="contactphone" />


    </p>
  </div>
</div>
<hr />

<br />
<div class="row">
  <div class="col-8">

    <Button
      variant="light"
      style={{ width: "80%", paddingLeft: "20px", marginBottom: "30px" }}
      class="btn btn-block"
      onClick={handleAddChange}
      className="btn-block">
      <PlusCircle />
    Save {" "}
    </Button>

  </div>
</div>
</div>

):(
<>
    {companies.map((company) => (
           
     <Accordion style={{ cursor: 'pointer', backgroundColor: 'transparent'}} >
      <Accordion.Item eventKey="0">
        <Accordion.Header className="accordion" style={{ cursor: 'pointer'}} onClick={() => {
                          setOpen1(!open1);
                          setSelectedCompany(company);
                          setEditMode(false);
                          
                          axios
                            .get(`${baseUrl}/company/${company.id}/admins`)
                            .then((value) => {
                              console.log("THEVALUE", value);
                              setCompanyAdmins(value.data);
                            });
                        } }>


                <div class="row ">
              
                    <div class="col-md-12 ">
                    <div style={{ width: 'max-content', height: 'max-content', padding: 1, background: 'white', overflow: 'hidden', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                <input type="hidden" value={company.id} name="company_id" />
                    <div style={{ width: 272, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex' }}>
                      <div style={{ color: 'black', fontSize: 23.10, fontFamily: 'Poppins', fontWeight: '100', wordWrap: 'break-word' }}> {company.companyname}</div>
                      <div style={{ alignSelf: 'stretch', paddingLeft: 4, paddingRight: 4, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                        <div style={{ paddingBottom: 1, paddingLeft: 10, paddingRight: 11, background: '#1B5A6F', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
                        <div data-max-characters="9" style={{ color: 'white', fontSize: 10, fontFamily: 'Poppins', fontWeight: '100',  textOverflow: 'ellipsis', width:'60px', whiteSpace: 'nowrap',overflow : 'hidden'  }}>{company.type=='coffees_2'?'Lindvalls blanket':'SCA blanket'}</div>
                        </div>
                        <div style={{ color: 'black', fontSize: 14, fontFamily: 'Poppins', fontWeight: '100', wordWrap: 'break-word', marginLeft: 2, marginRight: 45 }}>Added {format(Date.parse(company.created_at), "MMM dd, yyyy")}</div>
                      </div>
                    </div>
                   
                  </div>
                       
                    </div>
                    
               
              </div>
         
        </Accordion.Header>
        <Accordion.Body>
        {selectedCompany && !editMode && (
              <div class="row" style={{ paddingTop: "50px" }}>
                <div class="contain justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h5>{selectedCompany.companyname}</h5>
                  </div>
                  <div class="colm">
                    <p
                    data-max-characters="9"
                      style={{
                        fontSize: "12px",
                        backgroundColor: "#1B5A6F",
                        color: "white",
                        textOverflow: 'ellipsis', width:'60px', whiteSpace: 'nowrap',overflow : 'hidden',
                        borderRadius: "3px 3px 3px 3px",
                        textAlign: "center",
                        marginTop: "5px",
                      }}>
                     {selectedCompany.type}
                    </p>
                  </div>
                  <div class="colum">
                    <Button
                      variant="warning"
                      onClick={onEdit}
                      class="btn2 d-flex justify-content-sm-end"
                      className="">
                      <PencilSquare />

                    </Button> 
                    <Button
                      variant="danger"
                      onClick={() => setSmShow(true)}
                      class="btn2 d-flex justify-content-sm-end"
                      className="">
                      <Trash />

                    </Button>
                   </div>
                  
                </div>
   
                <Modal
                  size="sm"
                  show={smShow}
                  onHide={() => setSmShow(false)}
                  aria-labelledby="example-modal-sizes-title-sm"
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                      Delete the Company
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Are You Sure Want to Delete  Company ? </Modal.Body>
                  <Modal.Footer>

                    <Button variant="danger" onClick={() => handleDeleteCompany(selectedCompany.id)}>
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Address</h6>
                  </div>
                  <div class="col-md-6">
                    <p>{selectedCompany.address}</p>
                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>VAT No.</h6>
                  </div>
                  <div class="col-md-6 ">
                    <p>{selectedCompany.vatnumber}</p>
                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Contact</h6>
                  </div>
                  <div class="col-md-6 ">
                    <p>
                      {selectedCompany.contactname} <br />
                      {selectedCompany.contactemail}
                      <br />
                      {selectedCompany.contactphone}
                    </p>
                  </div>
                </div>
                <hr />
                <h6 class=" d-flex">Administrators</h6>
                <hr />

                {companyAdmins.map((companyAdmin) => (
                  <>
                    <div class="row justify-content-between">
                      <div class="col-md-6 d-flex">
                        {companyAdmin.firstname} {companyAdmin.lastname}
                        <br />
                        {companyAdmin.email}
                      </div>
                      {companyAdmin.isPrimary && (
                        <div class="col-md-6 d-flex justify-content-sm-center star">
                          Primary
                          <StarFill class="starti" color="#1B5A6F" />
                        </div>
                      )}
                      {companyAdmin.isPending && (
                        <div class="col-md-6 d-flex justify-content-sm-center ">
                          Awaiting response...
                        </div>
                      )}
                    </div>
                    <hr />
                  </>
                ))}
                <br />
                {!editMode && (

                  <div class="row">
                    <div class="row">
                    {inputFields.map((field, index) => (

                    <div key={index} style={{padding: '10px', margin: '10px' , border: '0.4px solid black', borderRadius: '10px' }} className="">
                    <Col >
                      <input type="hidden" name="companyid" value={selectedCompany.id} />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter first name"
                      name="fname"
                      value={field.fname}
                      onChange={(e) => handleInputChange2(index, 'fname', e.target.value)}
                    />
                    </Col>
                    <Col style={{marginTop: 5, marginBottom: 5}}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter last name"
                      name="lname"
                      value={field.lname}
                      onChange={(e) => handleInputChange2(index,'lname', e.target.value)}
                    />
                   
                    </Col>
                    <Col>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Admin Email"
                      name="email"
                      value={field.email}
                      onChange={(e) => handleInputChange2(index,'email', e.target.value)}
                    />
                    </Col>
                  
           
                    {/* {index === inputFields.length - 1 && (
                      <div className="input-group-append">
                        <Button
                          
                           color="green"
                          className="input-group-text bg-white"
                          id="basic-addon2"
                          onClick={handleAddField}
                             >
                          <PlusCircle color="black"/>
                        </Button>
                      </div>
                        )}  
                       */}
                        
                      </div>
                      
                    ))}

                    <Button variant="light" onClick={handleAddAdmin}> 
                      Add Admin
                    </Button>
                                  </div>
                  </div>
                )}

              </div>



            )}





            {selectedCompany && editMode && (

              <div class="col-md-6" style={{ paddingTop: "30px" }}>

                <div class="row justify-content-between">
                  <div class="col-md-6">
                    <input type="text" class="form-control" value={editMode ? editedName : selectedCompany?.companyname || ""}
                      onChange={(e) => setEditedName(e.target.value)} name="company_name" />


                  </div>
                  <div class="col-md-4">
                  <p
                      style={{}}>
                      {/* <select class="form-select"
                       value={editMode ? edittype : selectedCompany?.type || ""}
                        name="type"
                        onChange={(e) => setEditType(e.target.value)}
                        aria-label="Default select example">
                         <option disabled value="">
                            Form Type
                          </option>
                        <option value="coffees">SCA blanket</option>
                        <option value="coffees_2">Lindvalls blanket</option>
                      </select> */}
                    </p>
                  </div>

                </div>

                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Address</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">

                    <input type="text" class="form-control" value={editMode ? editedAddress : selectedCompany?.address || ""}
                      onChange={(e) => setEditedAddress(e.target.value)} name="company_address" />
                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>VAT No.</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">
                    <input type="text" class="form-control" value={editMode ? editedVatNumber : selectedCompany?.vatnumber || ""}
                      onChange={(e) => setEditedVatNumber(e.target.value)} name="vat_num" />

                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Contact</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">
                    <p>

                      <input type="text" class="form-control" value={editMode ? editedContactName : selectedCompany?.contactname || ""}
                        onChange={(e) => setEditedContactName(e.target.value)} name="contact_name" />

                      <br />

                      <input type="text" class="form-control" value={editMode ? editedContactEmail : selectedCompany?.contactemail || ""}
                        onChange={(e) => setEditedContactEmail(e.target.value)} name="contact_email" />

                      <br />
                      <input type="text" class="form-control" value={editMode ? editedContactPhone : selectedCompany?.contactphone || ""}
                        onChange={(e) => setEditedContactPhone(e.target.value)} name="contact_phone" />


                    </p>
                  </div>
                </div>
                <hr />
                <h6 class=" d-flex">Administrators</h6>
                <hr />

                {companyAdmins.map((companyAdmin) => (
                  <>
                    <div class="row justify-content-between">
                      <div class="col-md-6 d-flex">
                      {companyAdmin.firstname} {companyAdmin.lastname}
                        <br />
                     {companyAdmin.email} 
                      </div>
                      {companyAdmin.isPrimary && (
                        <div class="col-md-6 d-flex justify-content-sm-center star">
                          Primary
                          <StarFill class="starti" color="#1B5A6F" />
                        </div>
                      )}
                      {!companyAdmin.isPrimary && (
                        <div class="col-md-6">
                          <Row>
                            {/* <Col>
                              <Button
                                class="btn2 d-flex justify-content-sm-end"
                                className="btn2" style={{ fontSize: "12.5px" }}
                                onClick={() => handleMakePrimary(companyAdmin.email)}
                                >
                                <ArrowUp />
                                Make Primary  {" "}
                              </Button></Col>*/}
                              <Col> 
                              <Button
                                class="btn2 d-flex justify-content-sm-end"
                                className="btn2" style={{ fontSize: "12.5px" }}
                                onClick={() => handleRemoveUser(companyAdmin.id)}
                                >
                                <Trash />
                                Remove  {" "}
                              </Button></Col></Row>
                        </div>
                      )}
                      {companyAdmin.isPending && (
                        <div class="col-md-6 d-flex justify-content-sm-center ">
                          Awaiting response...
                        </div>
                      )}
                    </div>
                    <hr />
                  </>
                ))}
                <br />
                <div class="row">
                  <div class="col-8">

                    <Button
                      class="btn2 d-flex justify-content-sm-end"
                      onClick={handleSaveChange}
                      className="btn2">
                      <PencilSquare />
                      Save Change {" "}
                    </Button>

                  </div>
                </div>
              </div>

              //   </div>
              // ))}
              //   </div>
            )}



        </Accordion.Body>
      </Accordion.Item>
      </Accordion>

            ))}
   </>
)}
</div>

          </Col>




    
           

</Row>

</section>
</div>
) : (
 
          <>
<div class="content">   
 <div class='sidebar'>
        <SideBar/>
      </div>
          
      <section refresh={refresh} class = "stuff">
     
                 
                 
          <div class="row">
            <div class="col-sm-4"   style={{width:350 }}>
            <div type='button' onClick={OnAdd}  style={{width: 290, height: 54,margin:20, padding:10, background: '#113946', boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.25)', borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
            <div style={{width: 38, height: 38, justifyContent: 'center', alignItems: 'center', gap: 6, display: 'flex'}}>
              <div style={{width: 32, height: 32, position: 'relative'}}>
                <div style={{width: 21.33, height: 21.33, left: 5.78, top: 5.33, position: 'absolute'}}><Plus size={23} color="white" /></div>
              </div>
            </div>
            <div style={{color: 'white', fontSize: 16.92, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}>New Company</div>
          </div>
              <strong style={{paddingLeft: '30px'}}>All Companies</strong><hr/>

      <div style={{height:'100vh', overflowY:'auto', }}>
              {companies.map((company) => (
                <>
                
                <div  class="row item" >
                  <div class="itemb">
                    <input type="hidden" value={company.id} name="company_id" />
                    <div style={{ width: 300, height: 85, padding: 16, background: 'white', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)', borderRadius: 16, overflow: 'hidden', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                <input type="hidden" value={company.id} name="company_id" />
                    <div style={{ width: 272, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex' }}>
                      <div style={{ color: 'black', fontSize: 18.10, fontFamily: 'Poppins', fontWeight: '100', wordWrap: 'break-word' }}> {company.companyname}</div>
                      <div style={{ alignSelf: 'stretch', paddingLeft: 4, paddingRight: 4, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                        <div style={{ paddingBottom: 1, paddingLeft: 10, paddingRight: 11, background: '#1B5A6F', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
                          <div data-max-characters="9" style={{ color: 'white', fontSize: 10, fontFamily: 'Poppins', fontWeight: '100',  textOverflow: 'ellipsis', width:'60px', whiteSpace: 'nowrap',overflow : 'hidden'  }}>{company.type=='coffees_2'?'Lindvalls blanket':'SCA blanket'}</div>
                        </div>
                        <div style={{ color: 'black', fontSize: 12, fontFamily: 'Poppins', fontWeight: '100', wordWrap: 'break-word', marginLeft: 4, marginRight: 10 }}>Added: {format(Date.parse(company.created_at), "MMM dd, yyyy")}</div>
                      </div>
                    </div>
                    <div style={{ width: 50, height: 66, paddingTop: 0, paddingBottom: 10, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                      <div style={{ width: 54, height: 64, position: 'relative', background: 'white', boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.25)', borderRadius: 48 }}>
                        <div style={{ width: 18.13, height: 32, left: 18,color: 'black', fontWeight: 'bolder', top: 15.50, position: 'absolute', }}><SlArrowRight
                          type="button"
                         
                          onClick={() => {
                            setSelectedCompany(company);
                            setEditMode(false);
                            setAddMode(false);
                            setCompId(company.id);

                            handlefeachadmin(company.id);
                            // axios
                            //   .get(`${baseUrl}/company/${company.id}/admins`)
                            //   .then((value) => {
                            //     console.log("THEVALUE", value);
                            //     setCompanyAdmins(value.data);
                            //   });
                          } }
                          size={28} /></div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                
              
                  
                  </>
              ))}
              </div>
            </div>



            {selectedCompany && !editMode && (
              <div class="col-md-5" style={{ paddingTop: "50px",}}>
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h5>{selectedCompany.companyname}</h5>
                  </div>
                  <div class="col-md-3">
                    <p
                      style={{
                        fontSize: "12px",
                        backgroundColor: "#1B5A6F",
                        color: "white",
                        width: "90px",
                        borderRadius: "3px 3px 3px 3px",
                        textAlign: "center",
                        marginTop: "5px",
                      }}>
                     {selectedCompany.type=='coffees_2'?'Lindvalls blanket':'SCA blanket'}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <Button
                      variant="warning"
                      onClick={onEdit}
                      class="btn2 d-flex justify-content-sm-end"
                      className="">
                      <PencilSquare />

                    </Button>
                    <span>.</span>
                    <Button
                      variant="danger"
                      onClick={() => setSmShow(true)}
                      class="btn2 d-flex justify-content-sm-end"
                      className="">
                      <Trash />

                    </Button>
                  </div>
                </div>
   
                <Modal
                  size="sm"
                  show={smShow}
                  onHide={() => setSmShow(false)}
                  aria-labelledby="example-modal-sizes-title-sm"
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                      Delete the Company
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Are You Sure Want to Delete  Company ? </Modal.Body>
                  <Modal.Footer>

                    <Button variant="danger" onClick={() => handleDeleteCompany(selectedCompany.id)}>
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
                <hr />
                <div class="row align-items-start">
                  <div class="col-md-6">
                  
                  <p>  <b >Address</b>
                 
                 <br />
                  <strong style={{marginLeft: 45}}> {selectedCompany.address}</strong></p>
                  </div>
                </div>
                <hr />
                <div class="row align-items-start">
                  <div class="col-md-6 ">
                    <p>
                    <b>VAT No.</b>
                 <br />
                 <strong style={{marginLeft: 45}}> {selectedCompany.vatnumber}</strong>
                  </p>
                  </div>
                </div>
                <hr />
                <div class="row align-items-start">
                  
                     <div class="col-md-6">
                      <p>
                      
                    <b>Contact</b>
               <br />
                 
                    <p style={{marginLeft: 45}}>
                    <b>Name:  <small> {selectedCompany.contactname}</small></b> <br />
                    <b>Email:   <small>{selectedCompany.contactemail}</small></b>
                      <br />
                      <b>Phone:  <small>{selectedCompany.contactphone}</small></b> 
                    </p>
                    </p>
                  </div>
                </div>
                <hr />
                <h6 class=" d-flex">Administrators</h6>
                <hr />

                {companyAdmins.map((companyAdmin) => (
                  <>
                    <div class="row justify-content-between">
                      <div class="col-md-6 d-flex">
                        {companyAdmin.firstname} {companyAdmin.lastname}
                        <br />
                        {companyAdmin.email}
                      </div>
                      {companyAdmin.isPrimary && (
                        <div class="col-md-6 d-flex justify-content-sm-center star">
                          Primary
                          <StarFill class="starti" color="#1B5A6F" />
                        </div>
                      )}
                      {companyAdmin.isPending && (
                        <div class="col-md-6 d-flex justify-content-sm-center ">
                          Awaiting response...
                        </div>
                      )}
                    </div>
                    <hr />
                  </>
                ))}
                <br />
                {!editMode && (

                  <div class="row">
                    <div class="col-12">
                    {inputFields.map((field, index) => (

                    <div key={index} style={{  border: '0.4px solid black', borderRadius: '10px' }} className="input-group mb-12 admin">
                    <Col  className="admin-input">
                      <input type="hidden" name="companyid" value={selectedCompany.id} />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First Name"
                      name="fname"
                      value={field.fname}
                      onChange={(e) => handleInputChange2(index, 'fname', e.target.value)}
                    />
                    </Col>
                    <Col className="admin-input">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name"
                      name="lname"
                      value={field.lname}
                      onChange={(e) => handleInputChange2(index,'lname', e.target.value)}
                    />
                    </Col>
                    <Col className="admin-input">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      value={field.email}
                      onChange={(e) => handleInputChange2(index,'email', e.target.value)}
                    />
                    </Col>
                    <Col>
                    </Col>
                   
                    {/* {index === inputFields.length - 1 && (
                      <div className="input-group-append">
                        <Button
                          
                           color="green"
                          className="input-group-text bg-white"
                          id="basic-addon2"
                          onClick={handleAddField}
                             >
                          <PlusCircle color="black"/>
                        </Button>
                      </div>
                        )} */}
                      </div>
                    ))}
            <hr />
                    <Button variant="light" onClick={handleAddAdmin}> 
                      Add Admin
                    </Button>
                                  </div>
                  </div>
                )}

              </div>



            )}


{!selectedCompany && !addMode && !editMode &&(
  <center class="col-md-6" style={{marginTop: 200}}><h3>Select a company   <br />  or create a new company 

  <span onClick={OnAdd} type='button' > {" .."+"  here"}</span></h3></center>
)}


            {selectedCompany && editMode && (

              <div class="col-md-6" style={{ paddingTop: "30px" }}>

                <div class="row justify-content-between">
                  <div class="col-md-6">
                    <input type="text" class="form-control" value={editMode ? editedName : selectedCompany?.companyname || ""}
                      onChange={(e) => setEditedName(e.target.value)} name="company_name" />


                  </div>
                  <div class="col-md-4">
                  <p
                      style={{}}>
                      {/* <select class="form-select"
                       value={editMode ? edittype : selectedCompany?.type || ""}
                        name="type"
                        onChange={(e) => setEditType(e.target.value)}
                        aria-label="Default select example">
                         <option disabled value="">
                            Form Type
                          </option>
                        <option value="coffees">SCA blanket</option>
                        <option value="coffees_2">Lindvalls blanket</option>
                      </select> */}
                    </p>
                  </div>

                </div>

                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Address</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">

                    <input type="text" class="form-control" value={editMode ? editedAddress : selectedCompany?.address || ""}
                      onChange={(e) => setEditedAddress(e.target.value)} name="company_address" />
                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>VAT No.</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">
                    <input type="text" class="form-control" value={editMode ? editedVatNumber : selectedCompany?.vatnumber || ""}
                      onChange={(e) => setEditedVatNumber(e.target.value)} name="vat_num" />

                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Contact</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">
                    <p>

                      <input type="text" class="form-control" value={editMode ? editedContactName : selectedCompany?.contactname || ""}
                        onChange={(e) => setEditedContactName(e.target.value)} name="contact_name" />

                      <br />

                      <input type="text" class="form-control" value={editMode ? editedContactEmail : selectedCompany?.contactemail || ""}
                        onChange={(e) => setEditedContactEmail(e.target.value)} name="contact_email" />

                      <br />
                      <input type="text" class="form-control" value={editMode ? editedContactPhone : selectedCompany?.contactphone || ""}
                        onChange={(e) => setEditedContactPhone(e.target.value)} name="contact_phone" />


                    </p>
                  </div>
                </div>
                <hr />
                <h6 class=" d-flex">Administrators</h6>
                <hr />

                {companyAdmins.map((companyAdmin) => (
                  <>
                    <div class="row justify-content-between">
                      <div class="col-md-6 d-flex">
                      {companyAdmin.firstname} {companyAdmin.lastname}
                        <br />
                     {companyAdmin.email} 
                      </div>
                      {companyAdmin.isPrimary && (
                        <div class="col-md-6 d-flex justify-content-sm-center star">
                          Primary
                          <StarFill class="starti" color="#1B5A6F" />
                        </div>
                      )}
                      {!companyAdmin.isPrimary && (
                        <div class="col-md-6">
                          <Row>
                            {/* <Col>
                              <Button
                                class="btn2 d-flex justify-content-sm-end"
                                className="btn2" style={{ fontSize: "12.5px" }}
                                onClick={() => handleMakePrimary(companyAdmin.email)}
                                >
                                <ArrowUp />
                                Make Primary  {" "}
                              </Button></Col>*/}
                              <Col> 
                              <Button
                                class="btn2 d-flex justify-content-sm-end"
                                className="btn2" style={{ fontSize: "12.5px" }}
                                onClick={() => handleRemoveUser(companyAdmin.id)}
                                >
                                <Trash />
                                Remove  {" "}
                              </Button></Col></Row>
                        </div>
                      )}
                      {companyAdmin.isPending && (
                        <div class="col-md-6 d-flex justify-content-sm-center ">
                          Awaiting response...
                        </div>
                      )}
                    </div>
                    <hr />
                  </>
                ))}
                <br />
                <div class="row">
                  <div class="col-8">

                    <Button
                      class="btn2 d-flex justify-content-sm-end"
                      onClick={handleSaveChange}
                      className="btn2">
                      <PencilSquare />
                      Save Change {" "}
                    </Button>

                  </div>
                </div>
              </div>

              //   </div>
              // ))}
              //   </div>
            )}


            {addMode && !editMode && (

              <div class="col-md-6" style={{ paddingTop: "30px" }}>

                <div class="row justify-content-between">
                  <div class="col-md-6">
                    <input type="text" placeholder="Enter Company Name" class="form-control" value={formData.companyname}
                      onChange={handleInputChange} name="companyname" />


                  </div>
                  <div class="col-md-3">
                    <p
                      style={{}}>
                      <select class="form-select"
                        value={formData.type}
                        name="type"
                        onChange={handleInputChange}
                        aria-label="Default select example">
                                  <option disabled value="">
                                Form Type
                              </option>
                        <option value="coffees_2">Lindvalls blanket</option>
                        <option value="coffees">SCA blanket</option>
             
                      </select>
                    </p>
                  </div>

                </div>

                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>Address</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">

                    <input type="text" placeholder="Enter Company Address" value={formData.address}
                      onChange={handleInputChange} class="form-control" name="address" />
                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-6 d-flex">
                    <h6>VAT No.</h6>
                  </div>
                  <div class="col-md-6 d-flex justify-content-sm-end">
                    <input type="text" placeholder="Enter Company Vat No" class="form-control" value={formData.vatnumber}
                      onChange={handleInputChange} name="vatnumber" />

                  </div>
                </div>
                <hr />
                <div class="row justify-content-between">
                  <div class="col-md-3 d-flex">
                    <h6>Contact</h6>
                  </div>
                  <div class="col-md-9 d-flex justify-content-sm-start">
                    <p>
                      <label>Name</label>
                      <input type="text" placeholder="Enter Contact Name" class="form-control" value={formData.contactname}
                        onChange={handleInputChange} name="contactname" />

                      <br />
                      <label>Email</label>
                      <input type="email" placeholder="Enter Contact Email" class="form-control" value={formData.contactemail}
                        onChange={handleInputChange} name="contactemail" />

                      <br />
                      <label>Phone</label>
                      <input type="phone" placeholder="Enter Contact Phone" class="form-control" value={formData.contactphone}
                        onChange={handleInputChange} name="contactphone" />


                    </p>
                  </div>
                </div>
                <hr />
                
                <br />
                <div class="row">
                  <div class="col-8 d-flex justify-content-end">

                    <Button
                      variant="light"
                      style={{ width: "200px", paddingLeft: "20px", marginBottom: "30px" }}
                      class="btn btn-block"
                      onClick={handleAddChange}
                      className="btn-block">
                     
                      Add Company {" "}
                    </Button>

                  </div>
                </div>
              </div>

            )}

          </div>
          </section>
    </div>      
          </>

)}   
      
      
</>



  );
};
export default SuperHomeDesktop;
